import { useEffect, useMemo, useState } from "react";
import { type UserInformation } from "@root/clientFrontend/features/scout/types";
import { axios } from "@root/libs/axios";
import { csrfToken } from "@root/shared/utils/csrf";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";

type FetchParams = Record<string, unknown>;

// user_cassette_listはroot: 'data'のシリアライザ出力のみを返す（statusキーは存在しない）
type Response = { data?: UserInformation[] };

export const useScoutUserCassettes = (
  fetchUrl: string,
  fetchParams: FetchParams,
): UserInformation[] | null => {
  const [userCassettes, setUserCassettes] = useState<UserInformation[] | null>(null);

  useEffect(() => {
    let isMounted = true;

    const token = csrfToken() ?? "";

    // JSON送信のため、cache_scout_params等のネストしたHashもそのままサーバに届く
    axios
      .post<Response>(fetchUrl, {
        ...fetchParams,
        authenticity_token: token,
      })
      .then(({ data }) => {
        if (!isMounted) return;
        if (data.data) {
          setUserCassettes(data.data);
        }
      })
      .catch((error: unknown) => {
        if (!isMounted) return;
        // AxiosErrorをそのまま渡し、sendErrorLog内の通信断（ERR_NETWORK）除外を効かせる
        sendErrorLog(error as Error);
      });

    return () => {
      isMounted = false;
    };
  }, [fetchUrl, fetchParams]);

  return useMemo(() => userCassettes, [userCassettes]);
};
